import apiService from '../../services'
import router from '../../router'

const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
  ? {
    loggedIn: true,
    user,
    scopes: null }
  : {
    loggedIn: false,
    user: null,
    scopes: null
  }

export const auth = { // Modulo autenticazione
  namespaced: true,
  state: initialState,
  getters: {
    getLoggedUser: state => {
      return state.user
    }
  },
  actions: {
    login ({ commit }, user) {
      apiService
        .userLogin(user)
        .then(response => {
          /**
          * Set local storage with session data and user details
          */
          localStorage.setItem('loggedIn', true)
          localStorage.setItem('x-token', response.access_token)
          localStorage.setItem('token_type', response.token_type)
          /**
          * Retrieve logged user data and store it to the localStorage
          */
          apiService
            .getMe()
            .then(response => {
              response.role = response.type + ''
              localStorage.setItem('user', JSON.stringify(response))
              commit('loginSuccess', response)
            })
            .catch(error => {
              console.log('Error', error)
              commit('loginFailed')
            })
        })
        .catch(error => {
          console.log('Error', error.message)
          commit('loginFailed')
        })
    },
    logout ({ commit }) {
      apiService.logout()
      commit('logout')
    },
    register ({ commit }, user) {
      return apiService.register(user).then(
        response => {
          commit('registerSuccess')
          return Promise.resolve(response.data)
        },
        error => {
          commit('registerFailure')
          return Promise.reject(error)
        }
      )
    }
  },
  mutations: {
    loginSuccess (state, user) {
      state.user = user
      state.loggedIn = true
      router.push({ name: 'dashboard' })
    },
    loginFailed (state) {
      state.loggedIn = false
      state.user = null
    },
    logout (state) {
      state.loggedIn = false
      state.token = null
      state.user = null
    },
    registerSuccess (state) {
      state.loggedIn = true
    },
    registerFailure (state) {
      state.loggedIn = false
    }
  }

}
